import { ValidationMessages } from 'shared/models/Validation';
import * as yup from 'yup';

export const clientRoleValidationSchema = yup.object().shape({
    name: yup.string().trim().required(ValidationMessages.REQUIRED),
    description: yup.string().trim(),
});
